module.exports = __webpack_public_path__ + "img/logo-blue@2x.2daea90d.png";